module.exports = __webpack_public_path__ + "static/media/24_plantilla_cuadrada_combo_simple_cf_stills_tetra_1L_ades_alm_sa.103866f0.png";